module.exports = __webpack_public_path__ + "82725d08d871a5d50b8281ded6f12d72.jpg";